module.exports = __webpack_public_path__ + "static/media/tourism.8904ae75.svg";